import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { dataTransform } from '@nexio/emvio-util-app';
import Table from '../Table/Table';
import GenericDropDownFilter from '../Table/Filters/GenericDropDownFilter/GenericDropDownFilter';
import { transformDateCell } from '../../utils/cell';
import ProcessorOnboardingListItem from './ProcessorOnboardingListItem/ProcessorOnboardingListItem';
import {
    getProcessorOnboarding,
    getIsProcessorOnboardingLoading,
    getProcessorOnboardingErrorMessage,
    getCount,
    getPages
} from './processorOnboardingEntity';
import {
    getProcessorOnboarding as fetchProcessorOnboarding,
    fetchUrl
} from './processorOnboardingActions';
import BoardingStatusSummaryWidgetLegacy from '../BoardingStatusSummaryWidget/BoardingStatusSummaryWidgetLegacy';
import './ProcessorOnboarding.scss';

const APPLICATION_STATUSES = [
    'App Created',
    'Merchant Signed',
    'Sales Agent Signed',
    'Pre-Received',
    'Received',
    'Pending',
    'Underwritten',
    'Boarded',
    'Live',
    'Inactive',
    'Declined',
    'Closed'
];

export class ProcessorOnboarding extends Component {
    static propTypes = {};

    constructor(props) {
        super(props);

        this.filterRef = React.createRef();

        this.defaultColumnsAndProps = [
            {
                accessor: 'merchantName',
                filterable: true,
                label: 'Merchant',
                minWidth: 220,
                show: true,
                sortable: true
            },
            {
                accessor: 'merchantId',
                filterable: true,
                label: 'Merchant ID',
                minWidth: 180,
                show: true,
                sortable: true
            },
            {
                accessor: 'status',
                filterable: true,
                Filter: ({ filter, onChange }) => (
                    <GenericDropDownFilter
                        filter={filter}
                        onChange={onChange}
                        values={APPLICATION_STATUSES}
                        ref={this.filterRef}
                    />
                ),
                label: 'Status',
                minWidth: 150,
                show: true,
                sortable: true
            },
            {
                accessor: 'dateAdded',
                Cell: transformDateCell,
                filterable: false,
                label: 'Date Added',
                minWidth: 125,
                show: true,
                transformData: dataTransform.dateTimezoneButHideTimezone,
                transformType: 'dateTimezoneButHideTimezone'
            },
            {
                accessor: 'signer',
                filterable: true,
                label: 'Signer',
                minWidth: 220,
                show: true,
                sortable: true
            },
            {
                accessor: 'phoneNumber',
                filterable: true,
                label: 'Phone',
                minWidth: 120,
                show: true,
                sortable: true
            },
            {
                accessor: 'agentName',
                filterable: true,
                label: 'Agent',
                minWidth: 220,
                show: true,
                sortable: true
            },
            {
                accessor: 'repCode',
                filterable: true,
                label: 'Rep Code',
                minWidth: 110,
                show: true,
                sortable: true
            }
        ];
    }

    getTableState = (tableState) => {
        this.setState({
            ...tableState
        });
    };

    filterOnchange = (status) => {
        this.filterRef.current.props.onChange(status);
    };

    render() {
        return (
            <div className="emvio-processor-onboarding">
                <BoardingStatusSummaryWidgetLegacy setFilter={this.filterOnchange}/>
                <Table
                    fetchUrl={fetchUrl}
                    className="emvio-processor-onboarding-table"
                    shouldHideDateRange={true}
                    defaultColumnsAndProps={this.defaultColumnsAndProps}
                    defaultSorted={[{
                        desc: true,
                        id: 'dateAdded'
                    }]}
                    fetchData={fetchProcessorOnboarding}
                    countSelector={getCount}
                    dataSelector={getProcessorOnboarding}
                    errorMessageSelector={getProcessorOnboardingErrorMessage}
                    isDataLoadingSelector={getIsProcessorOnboardingLoading}
                    pagesSelector={getPages}
                    itemKey="id"
                    hasNoCount={true}
                    ListItemComponent={ProcessorOnboardingListItem}
                    noDataText="No Applications Found"
                    uniqueTableName="BoardingStatus"
                    getTableState={this.getTableState}
                    filterable={true}
                    shouldUseProvidedMerchantName={true}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProcessorOnboarding));
